/** Dates are business dates in India Standard Time, carried as "YYYY-MM-DD" strings. */
const IST = "Asia/Kolkata";

export function todayIST(now: Date = new Date()): string {
  return now.toLocaleDateString("en-CA", { timeZone: IST });
}

/** Indian financial year label for a date: 2026-09-29 -> "2026-27"; 2027-02-01 -> "2026-27". */
export function financialYear(date: string | Date = new Date()): string {
  const d = typeof date === "string" ? date : todayIST(date);
  const [y, m] = d.split("-").map(Number) as [number, number];
  const start = m >= 4 ? y : y - 1;
  return `${start}-${String((start + 1) % 100).padStart(2, "0")}`;
}

/** First and last day of a financial year label. */
export function fyRange(fy: string): { from: string; to: string } {
  const start = Number(fy.slice(0, 4));
  return { from: `${start}-04-01`, to: `${start + 1}-03-31` };
}

export function addDays(date: string, days: number): string {
  const d = new Date(`${date}T00:00:00Z`);
  d.setUTCDate(d.getUTCDate() + days);
  return d.toISOString().slice(0, 10);
}

export function formatDate(date: string | Date, locale = "en-IN"): string {
  const d = typeof date === "string" ? new Date(`${date.slice(0, 10)}T00:00:00+05:30`) : date;
  return d.toLocaleDateString(locale, { day: "2-digit", month: "short", year: "numeric", timeZone: IST });
}

export function formatDateTime(ts: string | Date, locale = "en-IN"): string {
  const d = typeof ts === "string" ? new Date(ts) : ts;
  return d.toLocaleString(locale, { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit", timeZone: IST });
}
